/** Keep the legacy React alias and database field aligned when editing images. */
export function withArticleImage(article, imageUrl) {
  return { ...article, imageUrl: imageUrl || '', image_url: imageUrl || null };
}

/** datetime-local expects wall time, not the UTC prefix of an ISO timestamp. */
export function localDateTimeValue(isoDate) {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
